import { render, staticRenderFns } from "./FamilyContactButtons.vue?vue&type=template&id=a5c68302&scoped=true&"
import script from "./FamilyContactButtons.vue?vue&type=script&lang=ts&"
export * from "./FamilyContactButtons.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyContactButtons.vue?vue&type=style&index=0&id=a5c68302&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c68302",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow,VTooltip})
